export const SWEDISH_TRANSLATIONS = {
    sammio: {
        site: {
            name: 'Sammio - Strålsäkerhetscentralen (STUK)',
            name_short: 'Sammio'
        },
        search: 'Sökning',
        search_filters: {
            tip: 'Välj ämnesområden för att begränsa dina sökresultat'
        },
        search_redirect: 'Sökning',
        search_card: 'Sökning',
        help: 'Instruktioner',
        announcement: "Aktuelt",
        accessibility: 'Tillgänglighetsförklaring',
        bookmarks: {
            title: 'Minneslista',
            title_field: 'Namnet på minneslistan',
            add_all: 'Välj alla resultat till minneslistan',
            clear_all: 'Stryk alla resultat från minneslistan',
            back_to_search_results: 'Tillbaka till föregående sökresultat',
            reorder: 'Redigera ordningen av resultat',
            empty: 'Minneslistan är tom.',
            show_in_cards: 'Visa på minneslistan',
            prompt_add_x_to_bookmarks: 'Är du säker på att du vill tillägga {count} resultat på minneslistan?',
            prompt_clear_bookmarks: 'Är du säker på att du vill tömma minneslistan?',
            bookmark_selected_info: 'Bokmärke valt. Använd piltangenterna för att flytta bokmärket till önskad plats. Tryck på ESC-tangenten för att avsluta bokmärkesredigeringen.',
            bookmark_not_selected_info: 'Inget bokmärke valt. Använd mellanslagstangenten för att välja det bokmärke du vill flytta. Tryck på ESC-tangenten för att avsluta bokmärkesredigeringen.',
            bookmark_moved_up: 'Bokmärket har flyttats upp. Ny plats är {location}',
            bookmark_moved_down: 'Bokmärket har flyttats ned. Ny plats är {location}',
            add_to_bookmarks: 'Lägg till mål i bokmärkena',
            added_to_bookmarks: 'Mål har lagts till i bokmärkena',
            remove_from_bookmarks: 'Ta bort mål från bokmärkena',
            removed_from_bookmarks: 'Målet borttaget från bokmärkena',
            items: 'Föremål'
        },
        bookmarks_get: {
            title: 'Minneslista'
        },
        statutes: {
            title: 'Förordningar och föreskrifter',
            side_navigation_go_to: 'Gå till aktuell sida i sidnavigeringen',
            side_navigation_no_results: 'Ingen aktuell sida hittades i sidonavigeringen. Välj ny sida.'
        },
        statutes_root: {
            title: 'Förordningar och föreskrifter'
        },
        statutes_card: {
            title: 'Förordningar och föreskrifter'
        },
        frequentsearches: {
            title: "Färdiga sökningar"
        },
        subsectionTitle: 'Bestämmelser',
        subsection: 'moment',
        justification: 'Motivering',
        guidance: 'Anvisningar',
        export_pdf: 'Spara PDF',
        share: 'Dela',
        print: 'Skriv ut',
        show: 'Visa',
        target_fields: 'Sök efter ord från',
        filter_results: 'Avgränsa resultat',
        act: 'Lag',
        decree: 'Förordning',
        regulation: 'Föreskrift',
        by_radiation_act: 'strålsäkerhetslagens',
        by_subsection: 'momentets',
        provision: 'Grundbestämmelse',
        issued: 'angivits',
        regulated: 'föreskrivits',
        under: 'med stöd av',
        related_decrees: 'Närmare författningar',
        decrees: 'Författningar',
        related_regulations: 'Närmare föreskrifter',
        regulations: 'Föreskrifter',
        related_decrees_and_regulations: 'Närmare författningar och föreskrifter',
        open: 'Öppna',
        openMenu: 'öppna menyn',
        close: 'Sluta',
        closeMenu: 'Stäng menyn',
        yes: 'Ja',
        no: 'Ej',
        clear: 'Töm',
        copy: "Kopiera",
        link_to_page: 'Länken till sidan',
        do_search: 'Sök',
        remove: 'Ta bort',
        removed: 'Tog bort',
        filter: 'Filter',
        remove_filter: 'Ta bort avgränsning',
        keyword: 'Sökord',
        searched_with_synonym: 'Visar också resultat för',
        active_filters: 'Avgränsningar',
        show_x_results: 'Uppvisas {count} resultat',
        added_x_results: 'Tillagt {count} resultat',
        added_one_result: 'Tillagt 1 resultat',
        clear_filters: 'Rensa alla val',
        search_field_placeholder: 'Sök bestämmelser, motiveringar och anvisningar med sökord',
        and: 'och',
        this_law_contains: 'I denna lag avses med',
        save: 'Spara',
        cancel: 'Avbryt',
        selected: 'Vald',
        unselected: 'Avmarkerad',
        url_copied_to_clipboard: 'Adressen har kopierats till klippbordet.',
        attachments_title: 'Bilagor',
        errors: {
            common_error: "Hoppsan, något gick fel. Var god och försök om en stund igen."
        },
        navigation: {
            title: "Huvudnavigation",
            site_pages: "Webbplatsens sidor",
            logo_text: "Sammio - till söksidan",
            saados:"Författningarnas meny",
            haku: "Sökningens filter",
            muistilista: 'Minneslista',
            menu: "Meny",
            usein_haetut: "Färdiga sökningar meny"
        },
        dropdown: {
            select_language: "Välj språk",
            description:  "Välj webbplatsens språk",
            change_to_language: "Ändra sidspråk till {lang}"
        },
        pagination: {
            next: 'Flytta till följande sida',
            previous: 'Flytta till föregående sida',
            goto_page: 'Flytta till sida  {0}',
            wrapper: 'Sökresultatens sidbrytning',
            current: 'Nuvarande sida {0}',
        },
        loading: {
            on: 'Läser in. Vänta.',
            done: 'Laddningen är klar.'
        },
        page_top: 'Till början',
        language: {
            fi: "Finska",
            sv: "Svenska",
            en: "Engelska"
        },
        news: {
            title: "Aktuell",
            no_publications: "Inga publicerade meddelanden",
            loading: "Laddar senaste nyheterna"
        }

    }
};
